import React from 'react';
import { motion } from 'framer-motion';

const STATS = [
  { value: '14', unit: 'days', label: 'free trial — no commitment' },
  { value: '$34.99', unit: '/mo', label: 'for both modules (bundle)' },
  { value: '1-click', unit: '', label: 'Schedule E & DSCR reports' },
  { value: '17%', unit: 'off', label: 'with annual billing' },
];

const INTEGRATIONS = ['Plaid', 'Stripe', 'Schedule E', 'DSCR'];

export const StatsBar: React.FC = () => (
  <section className="relative py-14 px-4 sm:px-6 overflow-hidden">
    {/* Subtle divider glow */}
    <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent" />
    <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-blue-500/20 to-transparent" />

    <div className="max-w-[1100px] mx-auto">
      {/* Stats grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-10">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1, duration: 0.5 }}
            className="text-center"
          >
            <div className="flex items-end justify-center gap-1 mb-1">
              <span className="text-3xl sm:text-4xl font-extrabold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent leading-none">
                {s.value}
              </span>
              {s.unit && (
                <span className="text-base font-bold dark:text-slate-400 text-gray-400 mb-0.5">{s.unit}</span>
              )}
            </div>
            <p className="text-xs dark:text-slate-500 text-gray-500">{s.label}</p>
          </motion.div>
        ))}
      </div>

      {/* Integration trust strip */}
      <div className="flex flex-wrap items-center justify-center gap-3">
        <span className="text-xs dark:text-slate-600 text-gray-400 uppercase tracking-widest font-semibold mr-2">Integrates with</span>
        {INTEGRATIONS.map(name => (
          <span key={name}
            className="px-3 py-1.5 rounded-full text-xs font-semibold dark:bg-white/[0.04] bg-gray-100 dark:text-slate-400 text-gray-600 dark:border-white/[0.07] border-gray-200 border">
            {name}
          </span>
        ))}
        <span className="px-3 py-1.5 rounded-full text-xs font-semibold dark:bg-blue-500/10 bg-blue-50 text-blue-500 dark:border-blue-500/20 border-blue-200 border">
          + more coming
        </span>
      </div>
    </div>
  </section>
);
